import { css, useTheme } from 'styled-components';
import { margin, padding, spacing } from "./mixins/Spacings.js";
import { font } from "./mixins/Fonts.js";
import { pinkPantherKallistoTokens } from "./kallistoTheme/tokens/index.js";
export var theme = {
  brandName: '',
  themeName: '',
  commons: {
    colors: {
      transparent: 'var(--lmn-ds-colors-null)',
      primary: 'var(--lmn-ds-colors-primary)',
      primary50: 'var(--lmn-ds-colors-primary-50)',
      primary100: 'var(--lmn-ds-colors-primary-100)',
      primary200: 'var(--lmn-ds-colors-primary-200)',
      primary300: 'var(--lmn-ds-colors-primary-300)',
      primary400: 'var(--lmn-ds-colors-primary-400)',
      primary500: 'var(--lmn-ds-colors-primary-500)',
      primary600: 'var(--lmn-ds-colors-primary-600)',
      primary700: 'var(--lmn-ds-colors-primary-700)',
      primary800: 'var(--lmn-ds-colors-primary-800)',
      secondary: 'var(--lmn-ds-colors-secondary)',
      secondary50: 'var(--lmn-ds-colors-secondary-50)',
      secondary100: 'var(--lmn-ds-colors-secondary-100)',
      secondary200: 'var(--lmn-ds-colors-secondary-200)',
      secondary300: 'var(--lmn-ds-colors-secondary-300)',
      secondary400: 'var(--lmn-ds-colors-secondary-400)',
      secondary500: 'var(--lmn-ds-colors-secondary-500)',
      secondary600: 'var(--lmn-ds-colors-secondary-600)',
      secondary700: 'var(--lmn-ds-colors-secondary-700)',
      secondary800: 'var(--lmn-ds-colors-secondary-800)',
      tertiary: 'var(--lmn-ds-colors-tertiary)',
      tertiary50: 'var(--lmn-ds-colors-tertiary-50)',
      tertiary100: 'var(--lmn-ds-colors-tertiary-100)',
      tertiary200: 'var(--lmn-ds-colors-tertiary-200)',
      tertiary300: 'var(--lmn-ds-colors-tertiary-300)',
      tertiary400: 'var(--lmn-ds-colors-tertiary-400)',
      tertiary500: 'var(--lmn-ds-colors-tertiary-500)',
      tertiary600: 'var(--lmn-ds-colors-tertiary-600)',
      tertiary700: 'var(--lmn-ds-colors-tertiary-700)',
      tertiary800: 'var(--lmn-ds-colors-tertiary-800)',
      accent: 'var(--lmn-ds-colors-accent)',
      accent50: 'var(--lmn-ds-colors-accent-50)',
      accent100: 'var(--lmn-ds-colors-accent-100)',
      accent200: 'var(--lmn-ds-colors-accent-200)',
      accent300: 'var(--lmn-ds-colors-accent-300)',
      accent400: 'var(--lmn-ds-colors-accent-400)',
      accent500: 'var(--lmn-ds-colors-accent-500)',
      accent600: 'var(--lmn-ds-colors-accent-600)',
      accent700: 'var(--lmn-ds-colors-accent-700)',
      accent800: 'var(--lmn-ds-colors-accent-800)',
      success: 'var(--lmn-ds-colors-success)',
      success50: 'var(--lmn-ds-colors-success-50)',
      success100: 'var(--lmn-ds-colors-success-100)',
      success200: 'var(--lmn-ds-colors-success-200)',
      success300: 'var(--lmn-ds-colors-success-300)',
      success400: 'var(--lmn-ds-colors-success-400)',
      success500: 'var(--lmn-ds-colors-success-500)',
      success600: 'var(--lmn-ds-colors-success-600)',
      success700: 'var(--lmn-ds-colors-success-700)',
      success800: 'var(--lmn-ds-colors-success-800)',
      warning: 'var(--lmn-ds-colors-warning)',
      warning50: 'var(--lmn-ds-colors-warning-50)',
      warning100: 'var(--lmn-ds-colors-warning-100)',
      warning200: 'var(--lmn-ds-colors-warning-200)',
      warning300: 'var(--lmn-ds-colors-warning-300)',
      warning400: 'var(--lmn-ds-colors-warning-400)',
      warning500: 'var(--lmn-ds-colors-warning-500)',
      warning600: 'var(--lmn-ds-colors-warning-600)',
      warning700: 'var(--lmn-ds-colors-warning-700)',
      warning800: 'var(--lmn-ds-colors-warning-800)',
      danger: 'var(--lmn-ds-colors-danger)',
      danger50: 'var(--lmn-ds-colors-danger-50)',
      danger100: 'var(--lmn-ds-colors-danger-100)',
      danger200: 'var(--lmn-ds-colors-danger-200)',
      danger300: 'var(--lmn-ds-colors-danger-300)',
      danger400: 'var(--lmn-ds-colors-danger-400)',
      danger500: 'var(--lmn-ds-colors-danger-500)',
      danger600: 'var(--lmn-ds-colors-danger-600)',
      danger700: 'var(--lmn-ds-colors-danger-700)',
      danger800: 'var(--lmn-ds-colors-danger-800)',
      gray: 'var(--lmn-ds-colors-gray)',
      gray0: 'var(--lmn-ds-colors-gray-0)',
      gray50: 'var(--lmn-ds-colors-gray-50)',
      gray100: 'var(--lmn-ds-colors-gray-100)',
      gray200: 'var(--lmn-ds-colors-gray-200)',
      gray300: 'var(--lmn-ds-colors-gray-300)',
      gray400: 'var(--lmn-ds-colors-gray-400)',
      gray500: 'var(--lmn-ds-colors-gray-500)',
      gray600: 'var(--lmn-ds-colors-gray-600)',
      gray700: 'var(--lmn-ds-colors-gray-700)',
      gray800: 'var(--lmn-ds-colors-gray-800)',
      gray1000: 'var(--lmn-ds-colors-gray-1000)',
      informative: 'var(--lmn-ds-colors-informative)',
      informative50: 'var(--lmn-ds-colors-informative-50)',
      informative100: 'var(--lmn-ds-colors-informative-100)',
      informative200: 'var(--lmn-ds-colors-informative-200)',
      informative300: 'var(--lmn-ds-colors-informative-300)',
      informative400: 'var(--lmn-ds-colors-informative-400)',
      informative500: 'var(--lmn-ds-colors-informative-500)',
      informative600: 'var(--lmn-ds-colors-informative-600)',
      informative700: 'var(--lmn-ds-colors-informative-700)',
      informative800: 'var(--lmn-ds-colors-informative-800)',
      pinkPeople: 'var(--lmn-ds-colors-pink-people)',
      pinkPeople50: 'var(--lmn-ds-colors-pink-people-50)',
      pinkPeople100: 'var(--lmn-ds-colors-pink-people-100)',
      pinkPeople200: 'var(--lmn-ds-colors-pink-people-200)',
      pinkPeople300: 'var(--lmn-ds-colors-pink-people-300)',
      pinkPeople400: 'var(--lmn-ds-colors-pink-people-400)',
      pinkPeople500: 'var(--lmn-ds-colors-pink-people-500)',
      pinkPeople600: 'var(--lmn-ds-colors-pink-people-600)',
      pinkPeople700: 'var(--lmn-ds-colors-pink-people-700)',
      pinkPeople800: 'var(--lmn-ds-colors-pink-people-800)',
      fsPrimary: 'var(--lmn-ds-colors-fs-primary)',
      fsPrimaryLight: 'var(--lmn-ds-colors-fs-primary-light)',
      fsPrimaryDark: 'var(--lmn-ds-colors-fs-primary-dark)',
      fsSecondary: 'var(--lmn-ds-colors-fs-secondary)',
      fsSecondaryLight: 'var(--lmn-ds-colors-fs-secondary-light)',
      eb: 'var(--lmn-ds-colors-eb)',
      ebLight: 'var(--lmn-ds-colors-eb-light)',
      myPrice: 'var(--lmn-ds-colors-myprice)',
      myPriceLight: 'var(--lmn-ds-colors-myprice-light)',
      myPriceDark: 'var(--lmn-ds-colors-myprice-dark)',
      tsh: 'var(--lmn-ds-colors-tsh)',
      tshLight: 'var(--lmn-ds-colors-tsh-light)',
      grayscaleSand: 'var(--lmn-ds-colors-grayscale-sand)',
      grayscaleLight: 'var(--lmn-ds-colors-grayscale-light)',
      grayscaleInactiveTab: 'var(--lmn-ds-colors-grayscale-inactive-tab)',
      grayscaleText: 'var(--lmn-ds-colors-grayscale-text)',
      plusBrandPrimary: 'var(--lmn-ds-colors-plus-brand-primary)',
      plusPrimaryDark: 'var(--lmn-ds-colors-plus-primary-dark)',
      plusPrimary: 'var(--lmn-ds-colors-plus-primary)',
      plusPrimaryLight: 'var(--lmn-ds-colors-plus-primary-light)',
      trustYouFair: 'var(--lmn-ds-colors-trust-you-fair)',
      trustYouOther: 'var(--lmn-ds-colors-trust-you-other)',
      trustYouPoor: 'var(--lmn-ds-colors-trust-you-poor)',
      trustYouGood: 'var(--lmn-ds-colors-trust-you-good)',
      trustYouVeryGood: 'var(--lmn-ds-colors-trust-you-verygood)',
      trustYouExcellent: 'var(--lmn-ds-colors-trust-you-excellent)'
    },
    elevations: {
      none: 'var(--lmn-ds-elevations-none)',
      small: 'var(--lmn-ds-elevations-small)',
      medium: 'var(--lmn-ds-elevations-medium)',
      large: 'var(--lmn-ds-elevations-large)'
    },
    breakpoints: {
      xxs: 'var(--lmn-ds-breakpoints-xxs)',
      xs: 'var(--lmn-ds-breakpoints-xs)',
      s: 'var(--lmn-ds-breakpoints-s)'
    },
    radius: {
      none: '0px',
      '2px': '2px',
      '4px': '4px',
      '6px': '6px',
      '8px': '8px',
      '16px': '16px',
      circle: '100%'
    },
    font: {
      sizes: {
        xsmall: 'var(--lmn-ds-font-size-xsmall)',
        small: 'var(--lmn-ds-font-size-small)',
        base: 'var(--lmn-ds-font-size-base)',
        medium: 'var(--lmn-ds-font-size-medium)',
        large: 'var(--lmn-ds-font-size-large)',
        xlarge: 'var(--lmn-ds-font-size-xlarge)',
        xxlarge: 'var(--lmn-ds-font-size-xxlarge)'
      },
      heights: {
        xsmall: 'var(--lmn-ds-font-height-xsmall)',
        small: 'var(--lmn-ds-font-height-small)',
        base: 'var(--lmn-ds-font-height-base)',
        medium: 'var(--lmn-ds-font-height-medium)',
        large: 'var(--lmn-ds-font-height-large)',
        xlarge: 'var(--lmn-ds-font-height-xlarge)',
        xxlarge: 'var(--lmn-ds-font-height-xxlarge)'
      },
      weights: {
        regular: 'var(--lmn-ds-font-weight-regular)',
        semiBold: 'var(--lmn-ds-font-weight-semiBold)',
        bold: 'var(--lmn-ds-font-weight-bold)'
      },
      family: 'var(--lmn-ds-font-family)',
      url: 'var(--lmn-ds-font-url)'
    }
  },
  kallisto: pinkPantherKallistoTokens.light,
  mixins: {
    borderRadius: function borderRadius(radius) {
      return css(["", ""], function (props) {
        return "border-radius: ".concat(props.theme.commons.radius[radius], ";");
      });
    },
    elevation: function elevation(_elevation) {
      return css(["", ""], function (props) {
        return "box-shadow: ".concat(props.theme.commons.elevations[_elevation], ";");
      });
    },
    spacing: spacing,
    padding: padding,
    margin: margin,
    font: font
  }
};
export var useLmnDsTheme = useTheme;

/*
  TODO: Remove ThemedStyledProps definition once this MR will be merged:
  https://github.com/styled-components/styled-components/pull/4126
*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars